// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v1Ur","label":"styles_label__32ykG"};